module.exports = __webpack_public_path__ + "img/db.cdbf8041.png";